import HomePage from './home_page.svelte'
import Faqs from './faq.svelte';
import drafting_service from './drafting_service.svelte';
import pricing from './pricing.svelte';
import Estimate_service from './estimation_services.svelte';
import design_analysis from './design_analysis.svelte';
const pages = {
	'/': HomePage,
	'/drafting_service': drafting_service,
	'/pricing' : pricing,
	'/Faqs': Faqs,
	'/estimate_service' : Estimate_service,
	'/design_analysis' : design_analysis,
};

export default pages;